import { useEffect, useState } from 'react';


export const CommonAvatarWithName = (props) => {
    const { title, textclassname } = props;
    const [placeHolder, setplaceHolder] = useState('');

    useEffect(() => {
        const name = title?.split(' ');
        let string = "";
        name?.length && name?.forEach(element => {
            string += element?.charAt(0)?.toUpperCase()
        });
        setplaceHolder(string);

        //eslint-disable-next-line
    }, [title, props])

    return (<div {...props}>
        <span className={textclassname}> {placeHolder}</span>
    </div>)
}

